"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const ThrottlingNodeValidation_1 = require("../validations/ThrottlingNodeValidation");
class ThrottlingNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.THROTTLING };
    if (props.type !== types_1.NODE_TYPES.THROTTLING)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = nodeData || {};
    return deserializeData;
  }
  serialize(uiData) {
    let nodeData = uiData;
    return nodeData;
  }
  validate() {
    return new ThrottlingNodeValidation_1.ThrottlingNodeValidation().validate(
      this
    );
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.ThrottlingNode = ThrottlingNode;
//# sourceMappingURL=ThrottlingNode.js.map
